import React, { Component } from 'react';
import { Modal, ModalBody, UncontrolledAlert, Container, Row, Form, FormGroup, Label, Input,
	 Button, InputGroup,FormFeedback,InputGroupAddon  } from 'reactstrap';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { isMobile, isChrome, isSafari} from '../../utils/deviceInfo';
import If from '../Shared/If';
import axios from '../../axios';
import * as actionCreators from '../../modules/actions/index';
import './Login.css';
import './loginForm.css'
import {navigate_user_to_module,oktaImg,oktaLogo, parseCookie,loginImg, isTrivvyProduct, loginImgTrivvy} from '../../utils/constants'
import DaniLogo from './../../images/Dani.svg';
import * as url from '../../utils/url';
import * as valid from '../../utils/validations';

import { saveToken, saveShowInstructions, retrieveShowInstructions } from '../../utils/localStorage';

// import mixpanel from 'mixpanel-browser';

class SingleSignOn extends Component {

	constructor(props) {
		super(props);
		this.state = {
			email: {
				value: '',
				error: false
			},
			foundOrg:false,
			findOrg:false,
			orgEmail: {
				value: null,
				error: false
			},
			isLogin:false,
			password: {
				value: '',
				error: false
			},
			infoModel: !window.navigator.standalone && retrieveShowInstructions(), // Is app installed
			errorMessage: null,
			isFromResetLink : false
		}
		this.timer=null
	}


	getURLParameter =()=>{
		let params =this.props.location.search
		return JSON.parse(decodeURI(params).substring(params.indexOf('?')+1, params.length))
	}

	ssoLogin = () => {
		let cookie = parseCookie(document.cookie),
		param_res = this.getURLParameter()

		let payload = {
			...param_res,
			login_type:'sso'
		}

		let that= this
		axios.post(url.loginUser,payload, {headers: {
			'Authorization': 'Bearer basicauth'
		  }}).then((response) => {
			console.log('testing---', response.data)
			saveToken(response.data.autherizationToken);
			that.setState({email:payload.email, ...payload})
			that.props.onLoginSuccess({ ...response.data.userDetails,
				isSSO:true,
				autherizationToken: response.data.autherizationToken });
		}).catch((error) => {
			console.log('err---', error)
			if(error.response && error.response.data && (typeof error.response.data) === 'string') {
				that.setState({ ...this.state, errorMessage: error.response.data });
			} else {
				that.setState({ ...this.state, errorMessage: 'Unable to reach server.' });
			}
			return
		})
	}


	componentWillReceiveProps(nextProps) {
		// console.log('NextPRopss---',nextProps)
		// valid.logged_in_user_check(this.props, nextProps)
	
		if(nextProps.isAuthenticated){

			let{profile}=nextProps.user
			let{isSSO, orgAdmin, role,officeId, organizationId}=profile
			let{isSetupSkipped, isAnalytics}=organizationId
	  
			// if(officeId){
			// 	axios.get(url.fetchOfficeDetails(officeId._id)).then(({data}) => {
			// 	  const officeData = data.data;
			// 	  const {isOfficeConfigured} = officeData;
			// 	  this.props.onFetchOfficeSuccess({...officeData});
			//   	})
			// }
	  
			if(!nextProps.isPasswordChanged && (isSSO!=true)) {
			  this.props.history.replace('/change-password');
			} else if(!organizationId.isOrgConfigured && isSetupSkipped!=true && isAnalytics.status && orgAdmin) {
			  //orgnization is not configured. Take him to organisation setup.
			  const {staticHierarchy} = nextProps.user.profile.organizationId;
			  // if org-chart setup is complete. check for other incomplete steps
			  if(staticHierarchy) {
				axios.get(url.getExistingMappings(organizationId._id)).then(({data}) => {
				  const payload = data.data.mapping;
				  const {orgAdmin,isPasswordChanged,skippedSetup} = nextProps.user.profile;
				  const {position,performance,separation} = skippedSetup;
				  if(position && !performance) {
					this.props.history.replace('/setup/map-performance');
				  } else if (position && performance && !separation) {
					this.props.history.replace('/setup/map-separation');
				  } else if(position && performance && separation) {
					let url = navigate_user_to_module(organizationId,false,orgAdmin)
					this.props.history.push(url)
				  } else { //if none are skipped, go with the usual flow
					if(payload.gender.data.length === 0) {
					  this.props.history.replace('/setup/map-gender');
					} else if(payload.occupation.data.length === 0) {
					  this.props.history.replace('/setup/map-positions');
					} else if(payload.seniority.data.length === 0) {
					  this.props.history.replace('/setup/map-positions');
					} else if(payload.performance.data.length === 0) {
					  this.props.history.replace('/setup/map-performance');
					} else if(payload.separation.data.length === 0) {
					  this.props.history.replace('/setup/map-separation');
					} else {
					  this.props.history.replace('/setup/welcome');
					}
				  }
				}).catch((error) => {
				  this.props.history.replace('/setup/map-gender');
				})
				this.props.history.replace('/setup/welcome');
			  }else {
				this.props.history.replace("/setup/welcome");
			  }
			}else if (!nextProps.isProfileDetailsUpdated){
			  this.props.history.replace('/setup/welcome');
			} else if(nextProps.isProfileDetailsUpdated && (nextProps.isPasswordChanged || isSSO==true)){
				console.log('in sso line 157')
			  let url = navigate_user_to_module(organizationId,false,orgAdmin)
			  console.log('sso line 159 --- ', url)
			  this.props.history.push(url)
			}
		}
	}


	assignedUserDelay = ({ target })=>{
		let { value } = target;
		this.setState({customUser:value})
		clearTimeout(this.timer);
		this.timer = setTimeout(() => {
		  this.handleAssignUser(value);
		}, 1000);
	  }

	componentDidUpdate(){
		// clearTimeout(this.timer);
		// this.timer = setTimeout(() => {
		// 	this.ssoLogin() 
		// }, 2000);
		// this.ssoLogin()
	}

	componentDidMount() {
		clearTimeout(this.timer);
		this.timer = setTimeout(() => {
			this.ssoLogin() 
		}, 2000);
		
	}
 
	renderForm = (value) => {
		let cookie = parseCookie(document.cookie),
		param_res = this.getURLParameter()
		// results
 

		// if(cookie && Object.keys(cookie).length>0 && cookie.sso_cookie_response && cookie.sso_cookie_response!=null && cookie.sso_cookie_response!=undefined){
		// 	try{
		// 		let parse_res = JSON.parse(cookie.sso_cookie_response)
		// 		results = parse_res
		// 	}catch(err){
		// 		results = param_res
		// 	}
		// } else {
		// 	results = param_res
		// }

		// let cookie_parse = parseCookie(document.cookie) 
		// let cookie_json = JSON.parse(cookie_parse.sso_cookie_response)
		let{firstName,lastName,orgName, isOrgFound, isNewUser}= param_res 
		console.log('param_res --- ', param_res)
		// `Welcome to OurOffice ${firstName} ${lastName}. 
		// We're happy to have you and your company, ${orgName}, with us.`

			let displayText =param_res.isNewUser?"Redirecting you.": "Welcome back."
			console.log('param_res --- ', param_res.isNewUser)
			// if(isNewUser)
				return (
				<div className="login-wrap">
				
					<div className="login-html">
						<div className="login-sso-success-txt">
							Successfully signed in. {displayText}
						</div>

					

					</div>
					<img src={isTrivvyProduct()?loginImgTrivvy: loginImg} className="login-img-container" /> 
				</div>
				)
		
	}
	
	

	render() {
	
		return (
			<Container className="login-layout-container">
				<Row className="login-outer-wrapper">
					<div className="login-container-title"><img src={DaniLogo} className=""/>OurOffice</div>
					<div className="login-form-container">
							<If condition={isMobile}>
								<div className="text-center mt-4">
									<img style={{height:'66px',width:'91px',marginBottom:'15px',marginTop: '15px'}} src={DaniLogo}/>
								</div>
							</If>
							{/* {alert} */}
							{this.renderForm(alert, true)}
					</div>
					{/* { !isMobile && <LoginSide />} */}
				</Row>
				<Row>
					<div id="login-secondary" className="col-sm-12 mb10 pl30">
						<div className="text-center">
							© {(new Date().getFullYear())} <a href="https://www.ouroffice.io/">OurOffice, Inc</a>
						</div>
					</div>
				</Row>
			</Container>
		)
	}
}

const mapStateToProps = state => {
	// console.log('State after Login', state);
	return {
		user : state.user,
		isPasswordChanged: state.user.profile.isPasswordChanged,
		isProfileDetailsUpdated : state.user.profile.isProfileDetailsUpdated,
		isAuthenticated: (state.user.profile.autherizationToken && state.user.profile.autherizationToken !== null)
	}
}
const mapDispatchToProps = dispatch => {
	return {
		onLoginSuccess: (data) => dispatch(actionCreators.loginSuccess(data)),
		onLogoutSuccess: (data) => dispatch(actionCreators.logout()),
		onFetchOfficeSuccess : (data) => dispatch(actionCreators.fetchOfficeSuccess(data))
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(SingleSignOn);
